module.exports = __webpack_public_path__ + "static/img/skill-apex.6698654d.png";